import React, { useState, useEffect } from 'react';
import TopicCard from '../TopicCard';
import styles from './styles';

const TopicsList = ({ topics, viewMore }) => {
  const [visibleTopics, setVisibleTopics] = useState(9);

  useEffect(() => {
    if (viewMore) {
      setVisibleTopics(topics.length);
    } else {
      setVisibleTopics(9);
    }
  }, [viewMore, topics]);

  return (
    <>
      <div className="cards-wrapper mobile">
        {topics.slice(0, visibleTopics).map((topic) => (
          <TopicCard topic={topic} key={topic.id} />
        ))}
      </div>
      <div className="cards-wrapper">
        {topics.map((topic) => (
          <TopicCard topic={topic} key={topic.id} />
        ))}
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default TopicsList;
